import { getBaseUrl } from "../graphql/api";

export async function downloadExport(path: string, body?: any): Promise<void> {
   const url = `${getBaseUrl()}/api/exports/${path}`;
   const res = await fetch(url, {
      method: "POST",
      credentials: "include",
      mode: "cors",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body ?? {}),
   });
   if (!res.ok) {
      throw new Error(`Export failed: ${res.status} ${res.statusText}`);
   }

   let filename = "export.xlsx";
   const cd = res.headers.get("content-disposition") || "";
   const match = cd.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
   if (match) filename = decodeURIComponent(match[1]);

   const blob = await res.blob();
   const objectUrl = URL.createObjectURL(blob);
   const a = document.createElement("a");
   a.href = objectUrl;
   a.download = filename;
   document.body.appendChild(a);
   a.click();
   document.body.removeChild(a);
   URL.revokeObjectURL(objectUrl);
}
